<template>
  <div class="Index">
    <div class="window_bg"></div>
    <div class="haerd">
      <div class="haerd_left">
        <div class="backBtn" @click.stop.prevent="goBack">返 回</div>
        <div class="title">手机买菜</div>
      </div>
    </div>
    <div class="deer"></div>
    <div class="module_box">
      <!-- <div class="mt" @click.stop.prevent="goMt">
        <img class="icon" src="@/assets/mt_icon.png" alt="" />
        <div class="text">美团</div>
        <img class="arrow" src="@/assets/arrow_icon.png" alt="" />
      </div> -->
      <div class="tb" @click.stop.prevent="goTb">
        <img class="icon" src="@/assets/tb_icon.png" alt="" />
        <div class="text">淘宝</div>
        <img class="arrow" src="@/assets/arrow_icon.png" alt="" />
      </div>
      <div class="pdd" @click.stop.prevent="goPdd">
        <img class="icon" src="@/assets/pdd_icon.png" alt="" />
        <div class="text">拼多多</div>
        <img class="arrow" src="@/assets/arrow_icon.png" alt="" />
      </div>
    </div>
    <div class="prompt">请选择任意一款APP进行模拟体验</div>
  </div>
</template>
<script>
export default {
  name: "Index",
  data() {
    return {};
  },
  created() {},
  mounted() {},

  methods: {
    async goBack() {
      this.$router.replace({
        path: "/shopping/shoppingIndex",
      });
    },
    async goMt() {
      this.$router.push({
        path: "/shopping/dish/mt/index1",
      });
    },
    async goTb() {
      this.$router.push({
        path: "/shopping/dish/tb/index1",
      });
    },
    async goPdd() {
      this.$router.push({
        path: "/shopping/dish/pdd/index1",
      });
    },
  },
};
</script>

<style scoped lang="less">
.Index {
  position: relative;
  z-index: 1;
  width: 100%;
  height: 100%;
  /* 玫红 */
  background: linear-gradient(
    180deg,
    rgb(249, 92, 159) 6.107%,
    rgb(255, 131, 184) 20.611%,
    rgb(255, 235, 228) 99.237%
  );
  background-size: 100% 100%;
  border-radius: 0px;
  .window_bg {
    position: absolute;
    top: -50px;
    left: -50px;
    width: 630px;
    height: 684px;
    background: url(@/assets/colorBg/window_bg.png) no-repeat center;
    background-size: 100% 100%;
  }
}

.haerd {
  padding: 40px 30px;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  .haerd_left {
    position: relative;
    z-index: 1;
    .backBtn {
      cursor: pointer;
      width: 251px;
      height: 90px;
      background: url("@/assets/colorBg/backBtn.png") no-repeat center;
      background-size: 100% 100%;
      font-family: Microsoft YaHei;
      font-weight: bold;
      font-size: 40px;
      color: #ffffff;
      display: flex;
      justify-content: center;
      align-items: center;
      text-shadow: 0px 1px 5px rgba(200, 121, 0, 0.5);
      border-radius: 96.5px;
      box-shadow: 0px 6px 12px 1px rgba(182, 118, 118, 0.27);
    }
    .title {
      margin-top: 40px;
      // margin-left: 20px;
      font-family: SourceHanSansSC-Regular-2;
      font-weight: bold;
      font-size: 70px;
      width: 50vw;
      color: #ffffff;
      line-height: 1.2;
    }
  }
}
.deer {
  position: absolute;
  top: 110px;
  right: 70px;
  width: 251px;
  height: 303px;
  background: url(@/assets/shopping/shoppingIndex/shopping_deer.png) no-repeat
    center;
  background-size: 100% 100%;
}
.module_box {
  position: absolute;
  top: 410px;
  left: 50%;
  transform: translate(-50%);
  max-height: 730px;
  overflow-y: auto;
  padding: 0 10px;

  .mt {
    cursor: pointer;
    display: flex;
    align-items: center;
    // justify-content: space-around;
    width: 606px;
    height: 157px;
    background: linear-gradient(180deg, #f8da62 0%, #ffb21f 76%, #fdbe3a 100%);
    border-radius: 15px;
    margin-bottom: 30px;
    .icon {
      width: 90px;
      height: 90px;
      margin: 0 60px;
    }
    .text {
      font-family: Microsoft YaHei;
      font-weight: bold;
      font-size: 60px;
      color: #ffffff;
      margin-right: 180px;
    }
    .arrow {
      width: 25px;
      height: 45px;
    }
  }
  .tb {
    cursor: pointer;
    display: flex;
    align-items: center;
    // justify-content: space-around;
    width: 606px;
    height: 157px;
    background: linear-gradient(180deg, #ff9050 0%, #fb7132 75%, #fe8d4e 100%);
    border-radius: 15px;
    margin-bottom: 30px;
    .icon {
      width: 90px;
      height: 90px;
      margin: 0 60px;
    }
    .text {
      font-family: Microsoft YaHei;
      font-weight: bold;
      font-size: 60px;
      color: #ffffff;
      margin-right: 180px;
    }
    .arrow {
      width: 25px;
      height: 45px;
    }
  }
  .pdd {
    cursor: pointer;
    display: flex;
    align-items: center;
    // justify-content: space-around;
    width: 606px;
    height: 157px;
    background: linear-gradient(180deg, #ff7656 0%, #f7361f 52%, #f94630 100%);
    border-radius: 15px;

    .icon {
      width: 90px;
      height: 90px;
      margin: 0 60px;
    }
    .text {
      font-family: Microsoft YaHei;
      font-weight: bold;
      font-size: 60px;
      color: #ffffff;
      margin-right: 120px;
    }
    .arrow {
      width: 25px;
      height: 45px;
    }
  }
}
.prompt {
  width: 100%;
  position: absolute;
  bottom: 70px;
  // left: 50%;
  // transform: translate(-50%);
  font-family: Microsoft YaHei;
  font-weight: 400;
  font-size: 30px;
  color: #666666;
  text-align: center;
}
</style>
